import { jsx as n, jsxs as f } from "react/jsx-runtime";
import { d as m, al as l, ap as p } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as _ } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as d } from "../../utils/omitStyleRenderProps/index.js";
import { TooltipTrigger as y, Tooltip as u } from "../Tooltip/index.js";
import '../../assets/index12.css';const j = "_link_1jsss_1", k = "_truncate_1jsss_10", x = "_href_1jsss_28", $ = "_primary_1jsss_29", h = "_secondary_1jsss_41", r = {
  link: j,
  truncate: k,
  href: x,
  primary: $,
  secondary: h
}, b = _(
  ({ children: s, truncate: o = !1, variant: t = "primary", ...e }, c) => {
    const i = m(r.link, r[t], {
      [r.href]: !!e.href,
      [r.truncate]: o
    }), a = /* @__PURE__ */ n(
      l,
      {
        ...d(e),
        slot: null,
        ref: c,
        className: i,
        "data-component": "Link",
        "data-variant": t,
        children: s
      }
    );
    return o ? /* @__PURE__ */ f(y, { children: [
      a,
      /* @__PURE__ */ n(u, { children: typeof s != "function" ? s : void 0 })
    ] }) : a;
  }
), w = p;
export {
  b as Link,
  w as RouterProvider
};
